import { useLazyQuery } from "@apollo/client";
import { IS_SCOPE } from "../graphql/org-gql";
import { useEffect, useState } from "react";
import useAuth from "./useAuth";

export default function useScope(orgId: number, isLowerLevel: boolean): boolean {
  const [isScope, setIsScope] = useState<boolean>(false);
  const {isAdmin,isCoordinator} = useAuth();
  const [load] = useLazyQuery(IS_SCOPE, { variables: { orgId, isLowerLevel } });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await load();
        if(isAdmin)
          setIsScope(true)
        else if(isCoordinator&&response.data?.isScope)
          setIsScope(true)
        else
        setIsScope(false)
        //setIsScope(response.data?.isScope || false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [load]);

  return isScope;
}
